const urls = {
  facebook: "https://www.facebook.com/jmbwoody",
  linkedin: "https://www.linkedin.com/in/brian-woodward-3947b927",
  github: "https://github.com/jmbwoody/",
  resume: "https://docs.google.com/document/d/1PxIZWqFPF_K-2Ut6SwEXEPXegnD-Yrp4se49Keta3y8"
};

export default urls;
